export default __webpack_public_path__ + "static/media/signUpWorkFlow.771046a8.svg";